import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)


export default new Vuex.Store({
    state: {
        lang: '',
        
    },
    mutations: {
        updateLang(state, lang) {
            state.lang = lang
            if(state.lang == "esp"){
                localStorage.setItem("lang", "esp")
            }
            else if(state.lang == "eng"){
                localStorage.setItem("lang", "eng")
            }
        }
    }
})


// WEBPACK FOOTER //
// ./src/store.js